<div class="form-group" [ngClass]="{'has-error': showError}" >
  @if ((question.question_copy || question.email_version) && showLabel) {
    <label [innerHTML]="question.question_copy || question.email_version" class="form-group__label"></label>
  }
  <div class="input-wrap">
    <input currencyMask type="text"
      [(ngModel)]="value"
      [name]="uniqueControlName"
      [id]='uniqueId'
      [disabled]="readOnly"
      [placeholder]="question?.question_prompt"
      class="form-control"
      (ngModelChange)="validateInput()"
      [options]="maskOptions"  />
      @if (currency) {
        <div class="input-wrap-prepend">
          <div class="input-wrap-symbol">
            {{currency}}
          </div>
        </div>
      }
    </div>

    <div class="custom-input-range__labels">
      <small class="custom-input-range__labels-min">Min: <strong>{{currency}} {{questionService?.accounting?.formatNumber(question?.min_val)}}</strong></small>
      @if (question?.recommended) {
        <small class="custom-input-range__labels-mid">Recommended: <strong>{{currency}} {{questionService?.accounting?.formatNumber(question?.recommended)}}</strong></small>
      }
      <small class="custom-input-range__labels-max">Max: <strong>{{currency}} {{questionService?.accounting?.formatNumber(question?.max_val)}}</strong></small>
    </div>

    @if (showError) {
      <label class="form-control-error">
        <svg class="icon">
          <use xlink:href="#warning-filled"></use>
        </svg>
        Please enter a valid amount
      </label>
    }
  </div>
